import { nonUndefined } from "Utility";
import { FsPointsDistribution } from "db/model/match/Set/FsPointsDistribution";
import { PointsDistribution } from "model/Match/Set/PointsDistribution";

export const mapPointsDistribution = (
  fsModel: FsPointsDistribution
): PointsDistribution | undefined => {
  if (!fsModel.distribution) {
    return undefined;
  }

  return {
    distribution: nonUndefined(fsModel.distribution),
    dnfPoints: fsModel.dnfPoints,
  };
};
